/** @format */

import React from "react";
import { Alert } from "react-bootstrap";
import { Outlet } from "react-router-dom";
//import { useTranslation } from 'react-i18next';
import AuthFlag from "../auth/AuthFlag";
//import { useGetAllUserResourcesQuery } from './userSlice'

const Dashboard = () => {
  //const { t:_ } = useTranslation();
  //const { data, isLoading, isSuccess, error } = useGetAllUserResourcesQuery();

  return (
    <AuthFlag
      authGroup={["teacher"]}
      fallback={
        <Alert variant="warning">
          Dashboard route isn't ready yet for staff.
        </Alert>
      }
    >
      <Outlet />
    </AuthFlag>
  );
};

export default Dashboard;
